import { useState, useContext, useRef } from "react";
import { Row, Col, Button, Modal, Table } from "react-bootstrap";
import PermissionContext from "../../../Store/permission-context";

const ReceiptSalesRecordsModal = (props) => {
  const [AxiosError, setAxiosError] = useState("");
  const [reload, setreload] = useState(false);
  const [EnableCloseButton, setEnableCloseButton] = useState(true);
  const [ShowModal, setShowModal] = useState(props.showmodal);
  const [DeleteItems, setDeleteItems] = useState(props.DeleteItems);
  const [ThisReceiptDetails, setThisReceiptDetails] = useState(
    props.paymentReceipt.RDetails,
  );
  const OldThisReceiptDetails = useRef(
    JSON.parse(JSON.stringify(props.paymentReceipt.RDetails)),
  );

  const PCtx = useContext(PermissionContext);
  let errorbackground = {
    backgroundColor: "#f04e00",
    fontFamily: "Times New Roman",
  };
  let successbackground = {
    backgroundColor: "#00ca65",
    fontFamily: "Times New Roman",
  };

  const TextBox = {
    width: "50px",
    height: "30px",
    border: "1px solid brown",
    textAlign: "center",
  };

  const [errorBackStyle, seterrorBackStyle] = useState(errorbackground);
  const [successBackStyle, setsuccessBackStyle] = useState(successbackground);
  // console.log(props.paymentReceipt.RDetails);

  const UpdateReceipt = async () => {
    const updatedDetails = ThisReceiptDetails.map((item, i) => {
      const NopDiff =
        parseFloat(OldThisReceiptDetails.current[i].nop) - parseFloat(item.nop);
      const NouDiff =
        parseFloat(OldThisReceiptDetails.current[i].nou) - parseFloat(item.nou);
      return { ...item, nopdiff: NopDiff, noudiff: NouDiff };
    });
    setThisReceiptDetails(updatedDetails);
    let update = {
      RDetails: updatedDetails,
      OldRDetails: OldThisReceiptDetails.current,
    };
    // console.log(update);
    const UpdateReceipt = await PCtx.connectAxios(
      "updatesalesreceipt.php",
      update,
    );
    // console.log(UpdateReceipt);
    if (!UpdateReceipt.includes("Error")) {
      PCtx.displayAlert(
        "SUCCESS",
        "The receipt has been updated successfully. Select the receipt again to see the changes",
        "success",
      );
      // setreload(true);
      props.NextEvent(true);
    } else {
      PCtx.displayAlert(
        "ERROR",
        "The receipt cannot be updated. Please contact the administrator",
        "danger",
      );
    }
  };

  const ChangeNop = (e, Ind) => {
    if (isNaN(e.target.value)) {
      return;
    }
    let newdetails = [...ThisReceiptDetails];
    newdetails[Ind].nop = isNaN(e.target.value) ? 0 : e.target.value;
    setThisReceiptDetails(newdetails);
  };

  const ChangeNou = (e, Ind) => {
    if (isNaN(e.target.value)) {
      return;
    }
    let newdetails = [...ThisReceiptDetails];
    newdetails[Ind].nou = isNaN(e.target.value) ? 0 : e.target.value;
    setThisReceiptDetails(newdetails);
  };

  const EditThisItem = async (Ind) => {
    let newdetails = [...ThisReceiptDetails];
    let ROV = newdetails[Ind].ReadOnly;

    ROV = ROV === 1 ? 0 : 1;

    newdetails[Ind] = { ...newdetails[Ind], ReadOnly: ROV };
    // console.log(newdetails[Ind]);
    setThisReceiptDetails(newdetails);
  };

  const DeleteThisItem = async (
    rctid,
    itid,
    total,
    pft,
    ordername,
    ddb,
    nop,
    nou,
    rinfo,
  ) => {
    let del = {
      rctid: rctid,
      itid: itid,
      total: total,
      pft: pft,
      ordername: ordername,
      ddb: ddb,
      nop: nop,
      nou: nou,
      rpble: rinfo.RPayable,
      rpmode: rinfo.RMode,
      rcust: rinfo.RCust,
      rpft: rinfo.RPft,
      Username: PCtx.Username,
    };
    const DeleteItem = await PCtx.connectAxios("deletesalesitem.php", del);
    // console.log(DeleteItem);
    if (!DeleteItem.includes("Failure")) {
      let newreceipt = ThisReceiptDetails.filter((r) => r.salesid !== itid);
      setThisReceiptDetails(newreceipt);
      PCtx.displayAlert(
        "SUCCESS",
        ordername +
          " has been deleted successfully and the quantity has been returned  to the stock (inventory)",
        "success",
      );
      setreload(true);
      setEnableCloseButton(false);
    } else {
      PCtx.displayAlert(
        "ERROR",
        ordername + " cannot be deleted. Please contact the administrator",
        "danger",
      );
    }
  };

  const ConfirmDelete = async (
    rctid,
    itid,
    total,
    pft,
    ordername,
    ddb,
    nop,
    nou,
    rinfo,
  ) => {
    const confirmed = window.confirm(
      `Are you sure you want to delete "${ordername}" from this receipt?`,
    );
    if (!confirmed) return;
    await DeleteThisItem(
      rctid,
      itid,
      total,
      pft,
      ordername,
      ddb,
      nop,
      nou,
      rinfo,
    );
  };

  return (
    ShowModal && (
      <Modal
        show={ShowModal}
        onHide={props.NextEvent}
        backdrop="static"
        keyboard={false}
        style={{ fontFamily: "Times New Roman", color: "brown" }}
      >
        <Modal.Header style={successBackStyle} closeButton={EnableCloseButton}>
          <Modal.Title style={{ color: "white", fontSize: "15px" }}>
            ITEMS BOUGHT ON THIS RECEIPT
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            fontFamily: "Times New Roman",
          }}
        >
          <Row>
            <Col md={12} sm={12} xs={12}>
              <Row className="justify-content-around">
                <Col md={12} sm={12} xs={12}>
                  <Table striped bordered responsive>
                    <thead>
                      <tr>
                        <th>SN</th>
                        <th>ITEMS BOUGHT</th>
                        <th>BULK</th>
                        <th>UNIT</th>
                        <th>AMOUNT PAID</th>
                        <th>PROFIT</th>
                        {props.Group === "Group" && <th>DELETE</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {ThisReceiptDetails.map((rct, index) => (
                        <tr key={index}>
                          <td className="text-center">{index + 1}</td>
                          <td className="text-center">{rct.ordername}</td>
                          {DeleteItems ? (
                            <td className="text-center">{rct.nop}</td>
                          ) : (
                            <td className="text-center">
                              <input
                                style={TextBox}
                                type="text"
                                value={rct.nop}
                                onChange={(e) => ChangeNop(e, index)}
                              />
                            </td>
                          )}
                          {DeleteItems ? (
                            <td className="text-center">{rct.nou} </td>
                          ) : (
                            <td className="text-center">
                              <input
                                style={TextBox}
                                type="text"
                                value={rct.nou}
                                onChange={(e) => ChangeNou(e, index)}
                              />
                            </td>
                          )}
                          <td className="text-center">{rct.subtotal}</td>
                          <td className="text-center">{rct.profit}</td>

                          {DeleteItems && (
                            <td className="text-center">
                              <Button
                                variant="danger"
                                className="btn btn-sm"
                                onClick={() =>
                                  ConfirmDelete(
                                    rct.RID,
                                    rct.salesid,
                                    rct.subtotal,
                                    rct.profit,
                                    rct.ordername,
                                    rct.ddb,
                                    rct.nop,
                                    rct.nou,
                                    props.paymentReceipt.RInfo,
                                  )
                                }
                              >
                                -
                              </Button>
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Col>
              </Row>
              <Row className="justify-content-around mt-3">
                {!DeleteItems && (
                  <Col md={4} sm={4} xs={4}>
                    <Button
                      variant="success"
                      className="btn"
                      onClick={UpdateReceipt}
                    >
                      Update Receipt
                    </Button>
                  </Col>
                )}
                <Col md={4} sm={4} xs={4}>
                  <Button
                    variant="success"
                    className="btn"
                    onClick={() => props.NextEvent(reload)}
                  >
                    {DeleteItems ? "Update Receipt" : "Close"}
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    )
  );
};

export default ReceiptSalesRecordsModal;
